module.exports = __webpack_public_path__ + "img/holy.d23a54fc.jpg";